// Small React error boundary. Inert when nothing throws (renders its children untouched).
// On a render-time exception it logs the error with context and shows a fallback message with a
// Reload button. It never reads or writes any data store: no localStorage, no Supabase.
import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error: error || new Error("Unknown render error") };
  }

  componentDidCatch(error, info) {
    console.error(
      "[ErrorBoundary] render error in " + (this.props.label || "app") + ":",
      error && error.message ? error.message : error,
      info && info.componentStack ? info.componentStack : ""
    );
  }

  render() {
    if (!this.state.error) return this.props.children;
    const label = this.props.label || "This page";
    return (
      <div role="alert" style={{ margin: "24px auto", maxWidth: 520, padding: "18px 22px", background: "#FEF2F2", border: "1px solid #FCA5A5", borderRadius: 10, color: "#7F1D1D", fontFamily: "inherit", fontSize: 14, lineHeight: 1.5 }}>
        <div style={{ fontWeight: 700, marginBottom: 6 }}>{label} hit an unexpected error.</div>
        <div style={{ marginBottom: 12 }}>Nothing was changed or lost. Reload the page to try again.</div>
        <button
          type="button"
          onClick={() => { try { window.location.reload(); } catch (e) { console.error("[ErrorBoundary] reload failed:", e); } }}
          style={{ background: "#991B1B", color: "#fff", border: "none", borderRadius: 7, padding: "8px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer" }}
        >Reload</button>
      </div>
    );
  }
}
